import { computed, inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../shared/shared.global-service';
import {
    selectCurrentServiceId,
    selectCurrentServiceSettings,
    selectFolder,
    selectServices,
} from '../../../store/person/person.selectors';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import {
    SERVICE_SETTINGS_ANAMNESIS_TYPE_DEFAULT,
    SERVICE_SETTINGS_ANAMNESIS_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-anamnesis.type';
import { localDate } from '../../../../shared/pipes/local-date.pipe';
import { SessionService } from '../../../../../services/session.service';

@Injectable()
export class FolderAnamnesisPageStore extends ComponentStoreV2Factory {

    public readonly session = inject(SessionService);

    public anamneses = computed(() => {
        const items = this.data.getAnamneses()?.items || [];

        return items.map((item: any, index: number) => {
            return {
                ...item,
                data: item.anamnesis,
                createdAt: localDate(item.updatedAt, this.session),
                index,
            };
        });
    });

    folder = globalStore!.selectSignal(selectFolder);
    serviceId = globalStore!.selectSignal(selectCurrentServiceId);

    anamnesisSharingIds = computed(() => {
        return getSharingFolderIds(this.serviceId(), globalStore!.selectSignal(selectServices)(), this.folder()?.relatedFolders, SERVICE_SETTINGS_ANAMNESIS_TYPE_KEY);
    });

    anamnesisFolderIds = computed(() => {
        const folderId = this.folder()?.id;
        if (!folderId) return [];

        return [...new Set([Number(folderId), ...(this.anamnesisSharingIds() || [])])]
            .sort((first, second) => first - second);
    }, {
        equal: (previous, current) => previous.length === current.length
            && previous.every((folderId, index) => folderId === current[index]),
    });

    anamnesisSettings = globalStore!.selectSignal(
        selectCurrentServiceSettings(SERVICE_SETTINGS_ANAMNESIS_TYPE_KEY, SERVICE_SETTINGS_ANAMNESIS_TYPE_DEFAULT));

    showHbsagInput = computed(() => this.anamnesisSettings()?.showHbsag ?? true);
    showHivInput = computed(() => this.anamnesisSettings()?.showHiv ?? true);
    showRwInput = computed(() => this.anamnesisSettings()?.showRw ?? true);

}
